import { AGENT_STATUS } from '../../../models';

export const sortAgents = (agents = []) => agents.sort(
  (a = { status: AGENT_STATUS.OFFLINE }, b = { status: AGENT_STATUS.OFFLINE }) => { 
    if (a.status !== AGENT_STATUS.OFFLINE && b.status === AGENT_STATUS.OFFLINE) return -1;
    if (a.status === AGENT_STATUS.OFFLINE && b.status !== AGENT_STATUS.OFFLINE) return 1;
    return 0;
  }
);
